import React, { memo, useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconMobileAdd, IconMobileFavorite, IconMobileMain } from '@app/icons';
import { useUserContext } from '@app/providers';
import { ModalTenderCreate } from '@app/modals';
import { cn } from 'lib/utils';

const MobileMenu = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, company, showSignInModal } = useUserContext();
  const [modalTenderCreateVisible, setModalTenderCreateVisible] =
    useState(false);

  const closeModalTenderCreate = useCallback(() => {
    setModalTenderCreateVisible(false);
  }, []);

  const handleClickMain = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const handleClickFavorites = useCallback(() => {
    navigate('/profile/favorites');
  }, [navigate]);

  const handleClickCreateTender = useCallback(
    (e: React.MouseEvent<HTMLButtonElement | HTMLLIElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (user.authenticated) {
        setModalTenderCreateVisible(true);
        return;
      }
      showSignInModal();
    },
    [showSignInModal, user.authenticated]
  );

  const menuItems = [
    {
      key: 'main',
      label: 'Главная',
      icon: <IconMobileMain />,
      onClick: handleClickMain,
      isActive: pathname === '/' && !modalTenderCreateVisible,
    },
    {
      key: 'add',
      label: '',
      icon: <IconMobileAdd />,
      onClick: handleClickCreateTender,
      isAdd: true,
      isActive: modalTenderCreateVisible,
    },
    {
      key: 'favorites',
      label: 'Избранное',
      icon: <IconMobileFavorite />,
      onClick: handleClickFavorites,
      isActive: pathname === '/profile/favorites',
    },
  ];

  return (
    <>
      <nav className="fixed bottom-0 left-0 w-full h-[60px] bg-white border-t flex z-[999] flex-nowrap md:hidden">
        <ul className="flex w-full h-full items-center justify-around m-0 p-0 list-none">
          {menuItems.map((item) => (
            <li
              key={item.key}
              onClick={item.onClick}
              className={cn(
                'flex flex-col items-center justify-center flex-1 h-full cursor-pointer select-none transition-colors duration-150',
                item.isActive ? 'text-blue-600' : 'text-gray-400',
                item.isAdd ? 'relative z-10' : ''
              )}
              style={{ minWidth: 0 }}
            >
              {item.isAdd ? (
                <div className="bg-blue-600 rounded-full p-3 -mt-8 border-4 border-white shadow-lg flex items-center justify-center w-14 h-14 mx-auto">
                  <span className="text-white flex items-center justify-center">
                    {item.icon}
                  </span>
                </div>
              ) : (
                <>
                  <div className="flex items-center justify-center w-8 h-8 mx-auto">
                    {item.icon}
                  </div>
                  <span className="text-[11px] mt-1 font-medium leading-none whitespace-nowrap">
                    {item.label}
                  </span>
                </>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <ModalTenderCreate
        companyId={company?.id || null}
        visible={modalTenderCreateVisible}
        closeModal={closeModalTenderCreate}
      />
    </>
  );
};

export default memo(MobileMenu);
